import React from 'react';

import { DataTable, type TableColumn } from '@/src/ui';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';
import type { StudentMasteryByStandardDTO } from '../models/standardsReportDTOs';

interface StudentMasteryByStandardProps {
    data: StudentMasteryByStandardDTO[];
}

const StudentStandardMasteryTable: React.FC<StudentMasteryByStandardProps> = ({ data }) => {
    const columns: TableColumn[] = [
        {
            dataKey: 'standardCode',
            header: 'Standard',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'standardDescription',
            header: 'Skill / Description',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'domainName',
            header: 'Domain',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) =>
                r.domainShortName && r.domainName
                    ? `${r.domainShortName} – ${r.domainName}`
                    : r.domainShortName || r.domainName || '-',
        },
        {
            dataKey: 'questionsCorrect',
            header: 'Correct',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.questionsCorrect ?? 0}`,
        },
        {
            dataKey: 'questionsTotal',
            header: 'Total',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.questionsTotal ?? 0}`,
        },
        {
            dataKey: 'percentCorrect',
            header: 'Student %',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.percentCorrect ?? 0}%`,
        },
    ];

    return (
        <div className="w-full overflow-auto">
            <br />

            <div className="pl-4">
                <h2
                    className="inline-block text-lg px-2 py-2 pl-4 bg-[var(--pm-secondary-light)] text-[var(--pm-dark)] rounded-t-lg tracking-wide whitespace-nowrap"
                    style={{
                        fontFamily: 'Verdana, Geneva, sans-serif',
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.4)',
                    }}
                >
                    Standard Mastery
                </h2>
            </div>

            <DataTable
                data={data}
                columns={columns}
                tableName="StudentDomainMasteryTable"
                emptyMessage="No domain mastery found."
                rowsPerPageInitial={20}
                enableExportCSV
                enableExportExcel
                alternatingRowColor
                defaultSortColumn="domainName"
                defaultSortDirection="asc"
            />
        </div>
    );
};

export default StudentStandardMasteryTable;
